import {
  CURRENT_ACTIVATION_FEE,
  LEGACY_ACTIVATION_FEE,
  isCurrentTierActivationFee,
} from "./membershipConfig";

/**
 * Profit margin pool for 10-level referral on Ultra membership (paid or voucher).
 * Total when full chain qualifies = margin × 180% = ₹180 at ₹100 margin.
 */
export const FLAT_MEMBERSHIP_REFERRAL_PROFIT_MARGIN = 100;

export function isFlatMembershipPackage(packageData, packagePrice) {
  if (packageData?.isSubItemPackage) return false;
  const price = Number(packagePrice ?? packageData?.price);
  const fee = Number(packageData?.activationFee ?? price);
  return isCurrentTierActivationFee(fee) || price === CURRENT_ACTIVATION_FEE;
}

export function resolveMembershipLineActivationFee(pkg, order = null) {
  if (!pkg && !order) return null;

  const candidates = [
    pkg?.subItemsData?.activationFee,
    order?.subItemsData?.activationFee,
    pkg?.activationFee,
    order?.activationFee,
  ];

  for (const value of candidates) {
    if (value != null && value !== "") {
      const n = Number(value);
      if (!Number.isNaN(n)) return n;
    }
  }

  if (pkg?.isSubItemPackage || order?.isSubItemPackage) {
    return CURRENT_ACTIVATION_FEE;
  }

  const price = Number(pkg?.price);
  if (
    price === LEGACY_ACTIVATION_FEE ||
    price === CURRENT_ACTIVATION_FEE ||
    isCurrentTierActivationFee(price)
  ) {
    return price;
  }

  return null;
}

/**
 * Paid Ultra, sub-item Ultra + activation fee, and voucher redeems share one
 * 10-level pool (REFERRAL_COMMISSION_RATES × profit margin) → Cash Wallet.
 */
export function isMembershipMarginReferralPackage(pkg, order = null) {
  if (!pkg) return false;
  if (pkg.id === "membership-voucher") return true;
  if (pkg.category === "Membership Voucher") return true;
  if (pkg.isAutoFillUpgrade === true || pkg.category === "Auto Fill Upgrade") {
    return false;
  }
  if (isFlatMembershipPackage(pkg, pkg.price)) return true;

  const fee = resolveMembershipLineActivationFee(pkg, order);
  if (fee === LEGACY_ACTIVATION_FEE || isCurrentTierActivationFee(fee)) {
    return true;
  }
  return false;
}

/** Referral fields stored on cart order package lines for commission processing. */
export function resolvePackageReferralFields(packageData, packagePrice) {
  if (isMembershipMarginReferralPackage(packageData)) {
    return {
      referralShare: true,
      profitMargin:
        packageData?.profitMargin != null && packageData.profitMargin !== ""
          ? Number(packageData.profitMargin)
          : FLAT_MEMBERSHIP_REFERRAL_PROFIT_MARGIN,
    };
  }
  return {
    referralShare: packageData?.referralShare === true,
    profitMargin: Number(packageData?.profitMargin) || 0,
  };
}

export function membershipMarginReferralProfitMargin(pkg) {
  const { profitMargin } = resolvePackageReferralFields(pkg, pkg?.price);
  return profitMargin;
}
